// extracted by mini-css-extract-plugin
export var button = "_v-0";
export var buttonContent = "_v-e";
export var buttonGroup = "_v-c";
export var dontRestrainIconWidth = "_v-a";
export var dropdownButton = "_v-b";
export var iconContainer = "_v-9";
export var lg = "_v-4";
export var md = "_v-3";
export var pending = "_v-f";
export var sm = "_v-2";
export var spinner = "_v-d";
export var squared = "_v-8";
export var wrapText = "_v-g";
export var xl = "_v-5";
export var xs = "_v-1";
export var xxl = "_v-6";
export var xxxl = "_v-7";